/**
 * noindexPages.js — the geo pages that will be de-indexed once approved.
 *
 * WHY: these ~200 /hr-software-<place> pages are obscure markets with no Avani
 * presence, or sub-country cities that share their country's labour law and so
 * would only DUPLICATE their country page (Berlin/Munich/Frankfurt are all
 * German law). They cannot be made genuinely unique with real facts, so leaving
 * them indexed keeps dragging the whole site down under Google's scaled-content
 * signal. De-indexing them (noindex + drop from sitemap) is the recovery signal.
 *
 * SAFETY GATE: NOINDEX_ENABLED is FALSE. While false, NOTHING changes — the
 * mechanism is wired in prerender.js + RouteSEO.js but inert. Review the list
 * below, then flip NOINDEX_ENABLED to true to apply on the next build/deploy.
 * The pages stay fully live for ads and direct visitors either way; noindex only
 * tells search engines not to list them.
 *
 * SOURCE OF TRUTH: consumed by React (import) and scripts/prerender.js (which
 * evaluates the DATA-START..DATA-END slice — keep that slice import-free).
 */

/* DATA-START (pure data + helper — no imports; prerender.js evals this) */

const NOINDEX_ENABLED = true; // ← ON: the 199 obscure geo pages below are de-indexed

// 199 obscure/duplicate geo slugs (without the "hr-software-" prefix).
const NOINDEX_SLUGS = [
  "abuja", "accra", "addis-ababa", "afghanistan", "algeria",
  "amman", "amsterdam", "anchorage", "angola", "argentina",
  "athens", "atlanta", "austin", "austria", "baghdad",
  "baku", "baltimore", "bangkok", "bangladesh", "barcelona",
  "beirut", "belgium", "belgrade", "berlin", "bogota",
  "bolivia", "boston", "bratislava", "brazil", "brisbane-qld",
  "brussels", "bucharest", "budapest", "buenos-aires", "busan",
  "cairo", "cambodia", "cameroon", "cape-town", "casablanca",
  "charlotte", "chengdu", "chicago", "chile", "chittagong",
  "colombia", "colombo", "columbus", "czech-republic", "dallas",
  "dar-es-salaam", "denmark", "denver", "detroit", "dhaka",
  "durban", "ecuador", "egypt", "ethiopia", "finland",
  "frankfurt", "gdansk", "ghana", "greece", "guadalajara",
  "guangzhou", "hanoi", "helsinki", "ho-chi-minh-city", "hong-kong",
  "honolulu", "houston", "hungary", "indianapolis", "indonesia",
  "islamabad", "israel", "istanbul", "italy", "ivory-coast",
  "jakarta", "japan", "johannesburg", "jordan", "kampala",
  "kandy", "kansas-city", "karachi", "kathmandu", "katowice",
  "kazakhstan", "kenya", "khartoum", "krakow", "lagos",
  "lahore", "laos", "las-vegas", "lebanon", "libya",
  "lima", "ljubljana", "lodz", "los-angeles", "lusaka",
  "lyon", "madrid", "manila", "medellin", "mexico",
  "mexico-city", "miami", "milan", "minneapolis", "monterrey",
  "morocco", "mozambique", "munich", "myanmar", "nairobi",
  "nashville", "nepal", "new-jersey", "new-york", "nicosia",
  "nigeria", "norway", "orlando", "osaka", "pakistan",
  "paraguay", "paris", "peru", "peshawar", "philippines",
  "phnom-penh", "phoenix", "pittsburgh", "poland", "portland",
  "porto", "portugal", "prague", "quito", "raleigh",
  "reykjavik", "riga", "romania", "rome", "rotterdam",
  "russia", "sacramento", "salt-lake-city", "san-antonio", "san-diego",
  "san-francisco", "san-jose", "santiago", "sao-paulo", "seattle",
  "senegal", "seoul", "serbia", "seville", "shenzhen",
  "sofia", "south-korea", "spain", "sri-lanka", "stockholm",
  "sweden", "switzerland", "taipei", "taiwan", "tallinn",
  "tampa", "tanzania", "tbilisi", "thailand", "tokyo",
  "tunis", "tunisia", "turin", "turkey", "uganda",
  "ukraine", "uruguay", "uzbekistan", "valletta", "venezuela",
  "vienna", "vietnam", "vilnius", "warsaw", "washington-dc",
  "yangon", "zambia", "zimbabwe", "zurich",
];

const NOINDEX_SET = new Set(NOINDEX_SLUGS.map((s) => '/hr-software-' + s));

// True only when the gate is ON and this exact path is in the de-index list.
function isNoindexed(pathname) {
  if (!NOINDEX_ENABLED) return false;
  const p = String(pathname || '').replace(/\/+$/, '') || '/';
  return NOINDEX_SET.has(p);
}

/* DATA-END */

export { NOINDEX_ENABLED, NOINDEX_SLUGS, isNoindexed };
